import { v4 } from "uuid";
import { message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { OldTransactionsProps } from ".";
import { errorMessage } from "../../../../utils";
import apiBolsa from "../../../../services/apiBolsa";
import { useBroker } from "../../../../contexts/BrokerContext";
import { useAuth } from "../../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export const useOldTransactions = (): OldTransactionsProps => {
  const [changed, setChanged] = useState(false);
  const [loadingGet, setLoadingGet] = useState(false);
  const [loadingPut, setLoadingPut] = useState(false);
  const [oldPositionEdit, setOldPositionEdit] = useState<any>({});
  const [oldPositionList, setOldPositionList] = useState<any>(null);
  const [showAddPositionModal, setShowAddPositionModal] = useState(false);
  const { initIntegration, currentBroker } = useBroker();
  const navigate = useNavigate()
  const { user } = useAuth();

  const handleEditOldPosition = (item: any, index: number) => {
    setShowAddPositionModal(true);
    setOldPositionEdit(item);
  };

  const handleRemoveOldPosition = (item: any, index: number) => {
    const listOldPosition = oldPositionList.filter(
      (item: any, i: number) => i !== index
    );
    setOldPositionList(listOldPosition);
    setChanged(true);
  };

  const editOldPosition = (editItem: any) => {
    const listOldPositions = oldPositionList.map((item: any) =>
      editItem.id === item.id
        ? { ...item, ...editItem, price: editItem?.avgBuyPrice }
        : item
    );
    setOldPositionList(listOldPositions);
    setShowAddPositionModal(false);
    setOldPositionEdit({});
    setChanged(true);
  };

  const addOldPosition = (item: any) => {
    const listOldPosition: any[] = [...oldPositionList];
    const newPostion = {
      operation: item?.lendingSide && item?.lendingSide === "Doador" ? "C" : "V",
      avgBuyPrice: item?.avgBuyPrice,
      price: item?.avgBuyPrice,
      code: item?.code,
      feeB3: item?.feeB3 || 0,
      institution: "Desconhecida",
      date: new Date(2019, 11, 31),
      market: "Mercado a Vista",
      quantity: item?.quantity,
      month: 11,
      year: 2019,
      id: v4(),
    };

    if(item.lendingSide) Object.assign(newPostion, { lendingSide: item?.lendingSide});
    listOldPosition.push(newPostion);

    setOldPositionList(listOldPosition);
    setShowAddPositionModal(false);
    setChanged(true);
  };

  const saveOldPositions = useCallback(async () => {
    oldPositionList.map((item: any) => ({
      ...item,
      id: undefined,
    }));
    try {
      setLoadingPut(true);
      // await apiBolsa.post("/operation", { orders });
      // message.success("Dados salvos com sucesso!");
      setLoadingPut(false);
      navigate(`/${currentBroker?.path}/bolsa-darf`)
    } catch (err) {
      message.error(errorMessage);
      setLoadingPut(false);
      throw Error;
    }
  }, [oldPositionList, currentBroker, navigate]);

  const getOldTransactionsInit = useCallback(() => {
    setLoadingGet(true);
    apiBolsa
      .get("/operation?month=12&year=2019", {})
      .then((response) => {
        setOldPositionList(
          response.data?.[0]?.orders.length
            ? response.data?.[0].orders.map((item: any) => ({
                ...item,
                avgBuyPrice: item.price,
                id: item._id,
              }))
            : []
        );
        setLoadingGet(false);
      })
      .catch(() => {
        setLoadingGet(false);
        setOldPositionList([]);
        message.error(errorMessage);
      });
  }, [setOldPositionList]);

  useEffect(() => {
    if (user?.user?.cpf) {
      // getOldTransactionsInit();
    }
  }, [getOldTransactionsInit, initIntegration, user.user]);

  return {
    changed,
    loadingPut,
    setLoadingPut,
    loadingGet,
    setLoadingGet,
    oldPositionList,
    oldPositionEdit,
    setOldPositionEdit,
    showAddPositionModal,
    setShowAddPositionModal,
    addOldPosition,
    editOldPosition,
    saveOldPositions,
    handleEditOldPosition,
    handleRemoveOldPosition,
  };
};
